import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_UPLOAD_FROM_FILE_OPEN = "CE_MODAL_UPLOAD_FROM_FILE_OPEN";
export const ceModalUploadFromFileOpen = (clientContentID) => ({
  type: CE_MODAL_UPLOAD_FROM_FILE_OPEN,
  client_content_id: clientContentID,
});

export const CE_MODAL_UPLOAD_FROM_FILE_LOAD_FILE =
  "CE_MODAL_UPLOAD_FROM_FILE_LOAD_FILE";
export const ceModalUploadFromFileLoadFile = (file, fileContents, size) => ({
  type: CE_MODAL_UPLOAD_FROM_FILE_LOAD_FILE,
  file: file,
  fileContents: fileContents,
  size: size,
});

export const CE_MODAL_UPLOAD_FROM_FILE_SAVE = "CE_MODAL_UPLOAD_FROM_FILE_SAVE ";
export const ceModalUploadFromFileSave = (format) => ({
  type: CE_MODAL_UPLOAD_FROM_FILE_SAVE,
  format: format,
});

export const ceModalUploadFromFileCancel = () => ({
  type: CE_MODAL_CLOSE,
});
